import React, { useState } from 'react'
import * as Yup from 'yup'
import { FormikErrors, useFormik } from 'formik'
import clsx from 'clsx'
import { useMutation } from '@apollo/client'
import { CreateFranchiseAccount } from '../../../graphql/mutation'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'

type Props = {
  nextStep: any
  formData: any
  setFormData: any
  userDetails: any
  setUserDetails: any
}

const OnboardingSchema = Yup.object().shape({
  Fullname: Yup.string()
    .matches(/^[a-zA-Z0-9(),.\- ]*$/, 'Franchise contains invalid characters')
    .min(2, 'Minimum 2 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Franchise name is required'),
  Email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required')
  // ContactNumber: Yup.string()
  //   .min(10, 'Minimum 10 numbers')
  //   .max(10, 'Maximum 10 numbers')
  //   .required('Contact Number is required')
})

const ProfileDetails: React.FC<Props> = ({
  nextStep,
  formData,
  setFormData,
  userDetails,
  setUserDetails
}) => {
  const [selectedOptions, setSelectedOptions] = useState({
    Department: ''
  })
  const [loadingOl, setLoading] = useState(false)

  // const [createBgAccountBySales] = useMutation(CREATE_BG_ACCOUNT_BY_SALES)
  const [createFranchiseAccount] = useMutation(CreateFranchiseAccount, {
    context: {
      headers: {
        'access-control-allow-methods': 'Franchise'
      }
    }
  })

  const initialValues = {
    Fullname: !!userDetails ? userDetails.Fullname : '',
    Email: !!userDetails ? userDetails.Email : ''
    // ContactNumber: !!userDetails ? userDetails.ContactNumber : ''
  }

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: OnboardingSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      console.log(values)
      setLoading(true)
      createFranchiseAccount({
        variables: {
          input: {
            name: values.Fullname,
            email: values.Email
          }
        },
        context: {
          headers: {
            'access-control-allow-methods': 'Franchise'
          }
        }
      })
        .then((res: any) => {
          if (res.data.createFranchiseAccount.status === 200) {
            setLoading(false)
            console.log(res)
            toast.success(res.data.createFranchiseAccount.message)
            const updatedFormData = {
              ...formData,
              id: res.data.createFranchiseAccount.data.id
            }
            setFormData(updatedFormData)
            nextStep()
          } else {
            setLoading(false)
            toast.error(res.data.createFranchiseAccount.message)
            setSubmitting(false)
            // nextStep()
          }
        })
        .catch((err) => {
          console.log(err)
          nextStep()
        })
    }
  })

  if (loadingOl) {
    return <>Loading....</>
  }

  const getErrorMessage = (error: string | string[] | FormikErrors<any> | FormikErrors<any>[]) => {
    if (typeof error === 'string') {
      return error
    } else if (Array.isArray(error)) {
      return error.join(', ')
    } else {
      return JSON.stringify(error)
    }
  }
  return (
    <>
      <div id='kt_account_settings_profile_details' className='collapse show'>
        <form id='kt_account_profile_details_form' className='form' onSubmit={formik.handleSubmit}>
          {formik.status && (
            <div className='mb-lg-15 alert alert-danger'>
              <div className='alert-text font-weight-bold'>{formik.status}</div>
            </div>
          )}
          <div className='card-body border-top p-9'>
            <div className='row mb-6'>
              <h1 className=''>Profile Details</h1>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-semibold fs-6'>
                Franchise Name
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  type='text'
                  {...formik.getFieldProps('Fullname')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                      'is-invalid': formik.touched.Fullname && formik.errors.Fullname
                    },
                    {
                      'is-valid': formik.touched.Fullname && !formik.errors.Fullname
                    }
                  )}
                  placeholder='Franchise Name'
                />
                {formik.touched.Fullname && formik.errors.Fullname && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{getErrorMessage(formik.errors.Fullname)}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-semibold fs-6'>
                Official Email
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  type='text'
                  {...formik.getFieldProps('Email')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                      'is-invalid': formik.touched.Email && formik.errors.Email
                    },
                    {
                      'is-valid': formik.touched.Email && !formik.errors.Email
                    }
                  )}
                  placeholder='Email'
                />
                {formik.touched.Email && formik.errors.Email && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{getErrorMessage(formik.errors.Email)}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className='row mb-6 m-15'>
              <div className='col-lg-8 offset-lg-4'>
                <div className='d-flex justify-content-end'>
                  {/* "Next" button */}
                  <Link to='/franchise/all-lists'>
                    <button type='button' className='btn btn-lg btn-secondary  mb-5 m-1'>
                      Cancel
                    </button>
                  </Link>
                  <button
                    type='submit'
                    className='btn btn-lg btn-primary  mb-5 m-1'
                    disabled={formik.isSubmitting || !formik.isValid}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      {/* </div> */}
    </>
  )
}

export default ProfileDetails
